<script>
export default {
  name: "PokoPdfViewer",
  props:["pdfData", "visible"],
  data() {
    return {
    }
  },
  computed: {
    showModal: {
      get: function () {
        return this.visible
      },
      set: function (value) {
        if (!value) {
          this.$emit('close')
        }

      }
    },
    iframe_source: {
      get: function() {
        if(this.pdfData.length > 0)
          return 'data:application/pdf;base64,'+this.pdfData;
        else
          return ''
      }
    }
  }
}
</script>

<template>
  <v-dialog v-model="showModal" fullscreen persistent>
    <v-card flat>
      <v-toolbar dark class="primary">
        <v-btn icon @click.native="showModal = false" dark>
          <v-icon>fa-times</v-icon>
        </v-btn>
        <v-toolbar-title>Podgląd recept</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-container fluid>
          <v-row>
            <v-col cols="12">
              <iframe :src="iframe_source" width="100%" height="900"></iframe>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style scoped>

</style>